(() => {

  class LanguageSwitcher extends HTMLElement {

    // /services/currency/update?currency=EUR&country=AT&return_to=%2F%3F_fd%3D0%26pb%3D0
    // o = window.Shopify.locale, a = window.Shopify.country, r = null === (t = window.Shopify.currency) || void 0 === t ? void 0 : t.active, n && o && a && r) {
    // /browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&country[exclude]=AT&currency[enabled]=true&currency[exclude]=EUR&language[enabled]=true&language[exclude]=de&
  
    constructor() {
      super();
      // this.itemSelectedEvent = new Event('item_selected');
      // this.anchors = this.querySelectorAll('a');
      // this.anchors.forEach(a => a.addEventListener('click', e => {
      //   this.onAnchorClick(e, a);
      // }))
      this.form = this.querySelector('form');
      this.submitBtns = this.form.querySelectorAll('[data-submit]');
      this.currentCountry = window.Shopify.country;
      this.currentLocale = window.Shopify.locale;
      this.currentCurrency = window.Shopify.currency;
      this.languageSwitcherTrigger = this.querySelector('[data-language-switcher-trigger]');
      this.languageSwitcherClose = this.querySelector('[data-language-switcher-close]');
      
      if (this.languageSwitcherTrigger) {
        this.languageSwitcherTrigger.addEventListener('click', this.handleClick.bind(this));
      }
      if (this.languageSwitcherClose) {
        this.languageSwitcherClose.addEventListener('click', this.handleClose.bind(this));
      } 
  
      this.settings = this.querySelector('script');
      
      try {
        this.settings = JSON.parse(this.settings.innerHTML);
      } catch (error) {
        this.settings = null;
      }
  
      this.setupEventListeners();
  
      // if (this.settings) {
      //   console.log(this.settings);
      // }
  
      // fetch(`/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true&country[exclude]=${this.currentCountry}&currency[enabled]=true&currency[exclude]=${this.currentCurrency}&language[enabled]=true&language[exclude]=${this.currentLocale}&`).then(r => r.json()).then(
      //   r => {
      //     this.geolocationSuggestion = r;
      //     this.init();
      //   }
      // );
  
    }
  
    // init() {
    //   console.log(this.geolocationSuggestion);
    // }
  
    handleClick(e) {
      // document.querySelector('sticky-header').setDimensions();
      document.body.classList.toggle('header-curtain');
      document.body.classList.toggle('language-switcher--show');
      document.body.classList.toggle('overflow-hidden');
    }
  
    handleClose(e) {
      e.preventDefault();
      document.body.classList.remove('header-curtain');
      document.body.classList.remove('language-switcher--show');
      document.body.classList.remove('overflow-hidden');
    }
  
    setupEventListeners() {
      this.submitBtns.forEach(submitBtn => submitBtn.addEventListener('click', this.handleBtnClick.bind(this)));
    }
  
    handleBtnClick(e) {
      const localeCode = e.target.getAttribute('data-locale-code').toUpperCase();
      const countryCode = e.target.getAttribute('data-country-code').toUpperCase();
      this.form.insertAdjacentHTML('afterbegin', `
        <input name="locale_code" type="hidden" value="${localeCode}">
        <input name="country_code" type="hidden" value="${countryCode}">
      `);
      this.form.submit();
    }
  
  }
  
  customElements.define('language-switcher', LanguageSwitcher);

})();